import { render, staticRenderFns } from "./SearchResultContactItem.vue?vue&type=template&id=41e88d4c&scoped=true&"
import script from "./SearchResultContactItem.vue?vue&type=script&lang=js&"
export * from "./SearchResultContactItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultContactItem.vue?vue&type=style&index=0&id=41e88d4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e88d4c",
  null
  
)

export default component.exports